import React, { FC, useState } from 'react';
import { CircleQuestion } from '@gravity-ui/icons';
import { Button, Icon, Popup } from '@gravity-ui/uikit';
import classes from '../styles/UserSettings.module.css';
import { headerT } from '../../../i18n/header.i18n';

export const HelpMenu: FC = () => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const buttonRef = React.useRef(null);

    const handleLinkClick = () => {
        setShowMenu(false);
    };

    return (
        <>
            <Button
                ref={buttonRef}
                size="s"
                view="flat"
                onClick={() => setShowMenu((show) => !show)}
            >
                <Icon data={CircleQuestion} size={20} />
            </Button>
            <Popup
                anchorRef={buttonRef}
                open={showMenu}
                placement="left-start"
                onOutsideClick={() => setShowMenu(false)}
            >
                <ul className={classes['user-settings']}>
                    <li className={classes['user-settings__item']}>
                        <a
                            href="https://docs.yandex-team.ru/vzhik"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes['user-settings__link']}
                            onClick={handleLinkClick}
                        >
                            {headerT('documentation')}
                        </a>
                    </li>
                    <li className={classes['user-settings__item']}>
                        <a
                            href="https://abc.yandex-team.ru/services/vzhik"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes['user-settings__link']}
                            onClick={handleLinkClick}
                        >
                            {headerT('serviceInfo')}
                        </a>
                    </li>
                </ul>
            </Popup>
        </>
    );
};
